/**
 * Shopify Ticketholder Fields
 * Dynamically shows/hides ticketholder contact fields based on quantity.
 * Works with quantity inputs and Ajax quantity updates.
 *
 * Tuned for Horizon theme (quantity inside .quantity-selector).
 * Usage: Add this script to your product template or theme.liquid.
 */

(function() {
  'use strict';

  // Configuration – tuned for Horizon; .quantity-selector wraps the quantity input
  const CONFIG = {
    quantitySelector: '.quantity-selector input[name="quantity"], .quantity-selector input[type="number"], input[name="quantity"], .quantity__input, [data-quantity-input], #Quantity',
    productFormSelector: 'form[action*="/cart/add"], .product-form, [data-product-form]',
    insertBeforeSelector: '.product-form__submit, .product-form__buttons, [name="add"], button[type="submit"]', // Horizon: ticketholder section before Add to cart
    containerId: 'ticketholder-fields-container',
    fieldClass: 'ticketholder-fieldset',
    minQuantity: 1,
    maxQuantity: 50
  };

  function getQuantityInput(form) {
    const input = form.querySelector(CONFIG.quantitySelector);
    if (!input) return null;
    return input;
  }

  function getQuantity(form) {
    const input = getQuantityInput(form);
    if (!input) return CONFIG.minQuantity;
    const val = parseInt(input.value, 10);
    if (isNaN(val) || val < CONFIG.minQuantity) return CONFIG.minQuantity;
    if (val > CONFIG.maxQuantity) return CONFIG.maxQuantity;
    return val;
  }

  function createFieldset(index) {
    const num = index + 1;
    const prefix = 'Ticketholder ' + num;
    const fieldset = document.createElement('div');
    fieldset.className = CONFIG.fieldClass;
    fieldset.dataset.ticketholderIndex = index;
    fieldset.innerHTML =
      '<h4 class="ticketholder-fieldset__title">' + escapeHtml(prefix) + '</h4>' +
      '<div class="ticketholder-fieldset__grid">' +
        '<label class="ticketholder-fieldset__label">First Name <span class="required" aria-hidden="true">*</span></label>' +
        '<input type="text" name="properties[' + escapeHtml(prefix) + ' - First Name]" ' +
          'class="ticketholder-fieldset__input" required ' +
          'placeholder="First name" autocomplete="given-name">' +
        '<label class="ticketholder-fieldset__label">Last Name <span class="required" aria-hidden="true">*</span></label>' +
        '<input type="text" name="properties[' + escapeHtml(prefix) + ' - Last Name]" ' +
          'class="ticketholder-fieldset__input" required ' +
          'placeholder="Last name" autocomplete="family-name">' +
        '<label class="ticketholder-fieldset__label">Email <span class="required" aria-hidden="true">*</span></label>' +
        '<input type="email" name="properties[' + escapeHtml(prefix) + ' - Email]" ' +
          'class="ticketholder-fieldset__input" required ' +
          'placeholder="email@example.com" autocomplete="email">' +
        '<label class="ticketholder-fieldset__label">Phone</label>' +
        '<input type="tel" name="properties[' + escapeHtml(prefix) + ' - Phone]" ' +
          'class="ticketholder-fieldset__input" ' +
          'placeholder="Phone number" autocomplete="tel">' +
      '</div>';
    return fieldset;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function ensureContainer(form) {
    let container = document.getElementById(CONFIG.containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = CONFIG.containerId;
      container.className = 'ticketholder-fields';
      const insertBefore = form.querySelector(CONFIG.insertBeforeSelector) || form.querySelector('button[type="submit"]') || form.lastElementChild;
      if (insertBefore) {
        insertBefore.parentNode.insertBefore(container, insertBefore);
      } else {
        form.appendChild(container);
      }
    }
    return container;
  }

  function syncFieldsets(form) {
    const container = ensureContainer(form);
    const quantity = getQuantity(form);
    const existing = container.querySelectorAll('.' + CONFIG.fieldClass);
    const currentCount = existing.length;

    if (quantity === currentCount) return;

    if (quantity > currentCount) {
      for (let i = currentCount; i < quantity; i++) {
        container.appendChild(createFieldset(i));
      }
    } else {
      for (let i = currentCount - 1; i >= quantity; i--) {
        existing[i].remove();
      }
    }
  }

  function setupQuantityListeners(form) {
    const quantityInput = getQuantityInput(form);
    if (!quantityInput) return;

    const sync = () => syncFieldsets(form);

    quantityInput.addEventListener('change', sync);
    quantityInput.addEventListener('input', sync);

    // Theme quantity buttons often change the input value
    const wrapper = quantityInput.closest('.quantity-selector, .quantity, [data-quantity-wrapper]') || form;
    wrapper.addEventListener('click', function(e) {
      if (e.target.matches('button, [data-quantity-minus], [data-quantity-plus], .quantity__button')) {
        setTimeout(sync, 0);
      }
    });
  }

  function observeQuantityChanges(form) {
    const quantityInput = getQuantityInput(form);
    if (!quantityInput) return;

    const observer = new MutationObserver(function() {
      syncFieldsets(form);
    });

    observer.observe(quantityInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    // Also observe parent in case theme replaces the whole quantity block via Ajax
    const quantityBlock = quantityInput.closest('.quantity-selector, .quantity, .product-form__quantity, [data-quantity]');
    if (quantityBlock) {
      const blockObserver = new MutationObserver(function(mutations) {
        const form = document.querySelector(CONFIG.productFormSelector);
        if (form && getQuantityInput(form)) {
          setupQuantityListeners(form);
          syncFieldsets(form);
        }
      });
      blockObserver.observe(quantityBlock.parentNode, { childList: true, subtree: true });
    }
  }

  function init() {
    const form = document.querySelector(CONFIG.productFormSelector);
    if (!form) return;

    syncFieldsets(form);
    setupQuantityListeners(form);
    observeQuantityChanges(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify theme sections re-render (e.g. Ajax sections)
  document.addEventListener('shopify:section:load', init);
})();
